module.exports = __webpack_public_path__ + "img/hivis.79d61f4e.svg";